export default __webpack_public_path__ + "static/media/notice_inform_YesNo.32b31fcc.svg";